import React, { useEffect } from "react";
import { useAuth0 } from "../../providers/AuthProvider";
import { Outlet } from "react-router";

export const AuthLayout = () => {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (isLoading || isAuthenticated) {
      return;
    }
    const fn = async () => {
      await loginWithRedirect();
    };
    fn();
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  return isAuthenticated ? <Outlet /> : null;
};
